import { combineReducers } from "redux";
import { cartData } from "./cart/cartReducer";
import { productData } from "./product/productReducer";

// Combine individual reducers into a root reducer
export default combineReducers({
  cartData,
  productData,
});
